export default "__VITE_ASSET__DGN4ibQ2__";